import { RequestInterface } from '../interfaces/request';
import {UserSession} from "./userSession";
import {RequestType} from "./requestType";
import {Customer} from "./customer";
import {DepreciationAsset} from "../interfaces/depreciationAsset";
import {ReferrerInterface} from "../interfaces/referrer";
import {SupplierInterface} from "../interfaces/supplier";

export class Request implements RequestInterface {
    IDRequest?: number;
    FKIDUserSession?: number;
    user_session: UserSession;
    FKIDRequestType?: number;
    request_type: RequestType;
    FKIDCustomer?: number;
    customer?: Customer | null;
    CreationDate: Date | null;
    IDFolderGoogleDrive: string;
    IDFolderGoogleDriveSecondary: string;
    Email: string;
    EmailSecondary: string;
    InternalManagement: boolean;
    Referrer: string;
    ReferrerIDs?: number[];
    referrers?: ReferrerInterface[];
    SupplierIDs?: number[];
    suppliers?: SupplierInterface[];
    PaymentDetails: string;
    PaymentCost1: number;
    PaymentCost2: number;
    PaymentCostExpertise: number;
    PaymentCostCertification: number;
    ProgressStatus: number;
    Simplified: boolean;
    DataVariation: boolean;
    InitialAcceptance: boolean;
    CompanyName: string;
    IBAN: string;
    SupportBankName: string;
    SupportBankBIC: string;
    SDICode: string;
    LeasingCompanyName: string;
    ULALastBalance: string;
    Phone: string;
    MobilePhone: string;
    PrivacyAcceptance: boolean;
    WarrantAcceptance: boolean;
    AttorneyAcceptance: boolean;
    ReleaseAcceptance: boolean;
    CompanyParticipation: boolean | null;
    PartnersParticipation: boolean | null;
    InvestmentMode: string | null;
    InvestmentDuration: string | null;
    OperationalHeadquarters: string;
    OperationalHeadquartersProvince: string;
    OperationalHeadquartersAddress: string;
    OperationalHeadquartersHouseNumber: string;
    Concessions: boolean | null;
    ConcessionsDetails: string;
    AtecoCode: string;
    InvestmentType: string | null;
    InvestmentAmount: number | null;
    DepreciationRate: number | null;
    DepreciationAssets: DepreciationAsset[] | null;
    BusinessExpansion: boolean;
    VATNumber: string;
    Name: string;
    Surname: string;
    BirthPlace: string;
    BirthPlaceProvince: string;
    BirthDate: Date | null;
    City: string;
    Province: string;
    Address: string;
    HouseNumber: string;
    HeadOffice: string;
    HeadOfficeProvince: string;
    TaxCredit4Consulting: boolean | null;
    TaxCredit4Years: boolean | null;
    TaxCredit4YearsCompensation: number | null;
    TaxCredit4StartDate: Date | null;
    TaxCredit4EndDate: Date | null;
    TaxCredit5Regulations: boolean | null;
    TaxCredit5Sanctions: boolean | null;
    TaxCredit5BeneficialOwner: string;
    TaxCredit5Revisor: boolean | null;
    TaxCredit5RevisorEmail: string;
    TaxCredit5RevisorPhone: string;
    TaxCredit5CadastralCode: string;
    TaxCredit5CadastralSection: string;
    TaxCredit5CadastralSheet: string;
    TaxCredit5CadastralParticle: string;
    TaxCredit5CadastralSub: string;
    TaxCredit5YearEnd: boolean | null;
    TaxCredit4Goods: string;
    TaxCredit5Interventions: string;
    TaxCredit5EnergyConsumption: string;
    TaxCredit5Savings: string;
    TaxCredit5CertifierName: string;
    TaxCredit5CertifierSurname: string;
    TaxCredit5CertifierCF: string;
    TaxCredit5CertifierCode: string;
    TaxCredit5BusinessExpansion: string;
    TaxCredit5StartDate: Date | null;
    TaxCredit5EndDate: Date | null;
    TaxCredit5OtherProjects: boolean | null;
    TaxCredit5SpecialWaste: boolean | null;
    TaxCredit5StructureOwner: string;
    TaxCredit5DNSH: boolean | null;
    DNSCompleted: boolean;
    Iper4Completed: boolean;
    RevenueStamp: string;
    CUPCode: string;
    CUPCodePECSentDate: Date | string | null;
    CUPCodeEmailSentDate: Date | string | null;
    Notes: string;
    NotesPhase2: string;
    DecreeIdentificationCode: string;
    RUStatus: boolean | null;
    SupplierReleaseEmailSentDate: Date | string | null;
    DocumentsCheck: string;
    StartDateStatus: string;
    RUInFolder: boolean | null;
    RUTransmittedDate: Date | string | null;
    SabatiniContribution: string;
    PaymentRequest2Date: Date | string | null;
    PaymentRequest3Date: Date | string | null;
    PaymentRequest4Date: Date | string | null;
    PaymentRequest5Date: Date | string | null;
    PaymentRequest6Date: Date | string | null;
    PreventiveFileClientSentDate: Date | string | null;
    PreventiveSentDate: Date | string | null;
    PreventiveReceiptDate: Date | string | null;
    PreventiveClientSupplierEmailDate: Date | string | null;
    AdvanceInvoiceCopy: string;
    AdvanceSlipCopy: string;
    IntermediateFileClientSent: string;
    IntermediateSentDate: Date | string | null;
    IntermediateReceiptDate: Date | string | null;
    DocumentRequestEmailSentDate: Date | string | null;
    AuditorCertification: string;
    SigningFileClientSentDate: Date | string | null;
    CompletionSentDate: Date | string | null;
    CompletionReceiptDate: Date | string | null;
    CreditConfirmationDate: Date | string | null;
    AdvancePayment: string;
    Phase1FinalizationDate: Date | string | null;
    WorkplaceSafety: boolean | null;
    IncentivePercentageAmount: string;
    LeasingStipulation: string;
    Expert: string;
    ExpertEmail: string;
    PreventiveCode: string;
    IntermediateCode: string;
    CompletionCode: string;
    Expertise40: string;
    NotesCount?: number;

    constructor() {
        this.user_session = new UserSession();
        this.request_type = new RequestType();
        this.CreationDate = null;
        this.IDFolderGoogleDrive = '';
        this.IDFolderGoogleDriveSecondary = '';
        this.Email = '';
        this.EmailSecondary = '';
        this.InternalManagement = false;
        this.Referrer = '';
        this.PaymentDetails = '';
        this.PaymentCost1 = 0;
        this.PaymentCost2 = 0;
        this.PaymentCostExpertise = 0;
        this.PaymentCostCertification = 0;
        this.ProgressStatus = 1;
        this.Simplified = false;
        this.DataVariation = false;
        this.InitialAcceptance = false;
        this.CompanyName = '';
        this.IBAN = '';
        this.SupportBankName = '';
        this.SupportBankBIC = '';
        this.SDICode = '';
        this.LeasingCompanyName = '';
        this.ULALastBalance = '';
        this.Phone = '';
        this.MobilePhone = '';
        this.PrivacyAcceptance = false;
        this.WarrantAcceptance = false;
        this.AttorneyAcceptance = false;
        this.ReleaseAcceptance = false;
        this.CompanyParticipation = null;
        this.PartnersParticipation = null;
        this.InvestmentMode = null;
        this.InvestmentDuration = null;
        this.OperationalHeadquarters = '';
        this.OperationalHeadquartersProvince = '';
        this.OperationalHeadquartersAddress = '';
        this.OperationalHeadquartersHouseNumber = '';
        this.Concessions = null;
        this.ConcessionsDetails = '';
        this.AtecoCode = '';
        this.InvestmentType = null;
        this.InvestmentAmount = null;
        this.DepreciationRate = null;
        this.DepreciationAssets = null;
        this.BusinessExpansion = true;
        this.VATNumber = '';
        this.Name = '';
        this.Surname = '';
        this.BirthPlace = '';
        this.BirthPlaceProvince = '';
        this.BirthDate = null;
        this.City = '';
        this.Province = '';
        this.Address = '';
        this.HouseNumber = '';
        this.HeadOffice = '';
        this.HeadOfficeProvince = '';
        this.TaxCredit4Consulting = null;
        this.TaxCredit4Years = null;
        this.TaxCredit4YearsCompensation = null;
        this.TaxCredit4StartDate = null;
        this.TaxCredit4EndDate = null;
        this.TaxCredit5Regulations = null;
        this.TaxCredit5Sanctions = null;
        this.TaxCredit5BeneficialOwner = '';
        this.TaxCredit5Revisor = null;
        this.TaxCredit5RevisorEmail = '';
        this.TaxCredit5RevisorPhone = '';
        this.TaxCredit5CadastralCode = '';
        this.TaxCredit5CadastralSection = '';
        this.TaxCredit5CadastralSheet = '';
        this.TaxCredit5CadastralParticle = '';
        this.TaxCredit5CadastralSub = '';
        this.TaxCredit5YearEnd = null;
        this.TaxCredit4Goods = '';
        this.TaxCredit5Interventions = '';
        this.TaxCredit5EnergyConsumption = '';
        this.TaxCredit5Savings = '';
        this.TaxCredit5CertifierName = '';
        this.TaxCredit5CertifierSurname = '';
        this.TaxCredit5CertifierCF = '';
        this.TaxCredit5CertifierCode = '';
        this.TaxCredit5BusinessExpansion = '';
        this.TaxCredit5StartDate = null;
        this.TaxCredit5EndDate = null;
        this.TaxCredit5OtherProjects = null;
        this.TaxCredit5SpecialWaste = null;
        this.TaxCredit5StructureOwner = '';
        this.TaxCredit5DNSH = null;
        this.DNSCompleted = false;
        this.Iper4Completed = false;
        this.RevenueStamp = '';
        this.CUPCode = '';
        this.CUPCodePECSentDate = null;
        this.CUPCodeEmailSentDate = null;
        this.Notes = '';
        this.NotesPhase2 = '';
        this.DecreeIdentificationCode = '';
        this.RUStatus = null;
        this.SupplierReleaseEmailSentDate = null;
        this.DocumentsCheck = '';
        this.StartDateStatus = '';
        this.RUInFolder = null;
        this.RUTransmittedDate = null;
        this.SabatiniContribution = '';
        this.PaymentRequest2Date = null;
        this.PaymentRequest3Date = null;
        this.PaymentRequest4Date = null;
        this.PaymentRequest5Date = null;
        this.PaymentRequest6Date = null;
        this.PreventiveFileClientSentDate = null;
        this.PreventiveSentDate = null;
        this.PreventiveReceiptDate = null;
        this.PreventiveClientSupplierEmailDate = null;
        this.AdvanceInvoiceCopy = '';
        this.AdvanceSlipCopy = '';
        this.IntermediateFileClientSent = '';
        this.IntermediateSentDate = null;
        this.IntermediateReceiptDate = null;
        this.DocumentRequestEmailSentDate = null;
        this.AuditorCertification = '';
        this.SigningFileClientSentDate = null;
        this.CompletionSentDate = null;
        this.CompletionReceiptDate = null;
        this.CreditConfirmationDate = null;
        this.AdvancePayment = '';
        this.Phase1FinalizationDate = null;
        this.WorkplaceSafety = null;
        this.IncentivePercentageAmount = '';
        this.LeasingStipulation = '';
        this.Expert = '';
        this.ExpertEmail = '';
        this.PreventiveCode = '';
        this.IntermediateCode = '';
        this.CompletionCode = '';
        this.Expertise40 = '';
        this.NotesCount = 0;
    }
}
